import React, {useEffect, useRef, useState} from 'react';
import "../Menu/Menu.scss";
import 'swiper/swiper-bundle.css';
import {CouponData} from "../Menu/MenuServices";
import {useDispatchMall, useSpeech} from "../../hooks";
import '../../../node_modules/rc-tabs/assets/index.css';
import {useHistory, useLocation, useParams} from "react-router-dom";
import Rodal from "rodal";
import "./Coupon.scss";
import {ConvertTMonthName, fixNumbers, LoginRequest, MessageHandler, Validation} from "../../Services";
import toaster from "toasted-notes";
import {Message} from "toasted-notes/commonjs/Message";
import {CheckinData} from "../Scan/ScanServices";
import { Spin, Alert } from 'antd';
import 'antd/dist/antd.css';
import {ConvertToJalali} from "../StoreDetail/StoreDetailServices";
import SimpleLineIcon from "react-simple-line-icons";
import moment from "moment-jalaali";


const ConvertToJalaliSplited = (date) =>{
    if(date){
        let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        return day+" "+month+""+year
    }
    return ""
}


const escapeWord = "shop";



function Success(props) {
    return (
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return (
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


function Coupon() {

    const CatRef = useRef(null);
    const { couponId } = useParams();
    //hooks
    const history = useHistory()
    const setMall = useDispatchMall();

    const [mobile,setMobile] = useState("");
    const [couponCode,set_couponCode] = useState("");
    const [loginState,setLoginState] = useState(false);





    const [showModal, setShowModal] = useState(false);
    const [productItem, setProductItem] = useState({});
    const [merchant, set_merchant] = useState(null);
    const [isLogin, set_isLogin] = useState(false);
    const [coupon, set_coupon] = useState(false);


    const [couponLoading, set_couponLoading] = useState(false);







    useEffect(() => {
        window.scrollTo(0, 0);
        if(couponId){

            getCoupon(couponId)

            if(localStorage.getItem('token')){
                set_isLogin(true)
            }

        }
    }, [])




    const getCoupon = async (id) => {
        set_couponLoading(true)
        try{
            const response = await CouponData(id);
            console.log(response)
            set_coupon(response.data)
            set_merchant(response.data.merchant)
            set_couponLoading(false)
        }catch (e) {
            set_couponLoading(false)
        }

    }






    const Login_Request_Coupon = async () => {
        //get Coupon

        if(loginState){return }
        // pre request
        setLoginState(true);

        if (!Validation({type:"MOBILE",val:fixNumbers(mobile)})){
            MessageHandler({type:"VALIDATION",status:"MOBILE"})
            setLoginState(false);
            return ;
        }

        if(!merchant){
            if(couponCode===""){
                toaster.notify(({ onClose }) => (<Error   message={"لطفا کد کوپن را وارد نمایید"}/>),{duration: 2000});
                setLoginState(false);
                return ;
            }
        }


        try {
            const cop_response = await CouponData(couponCode);
            console.log("Cop : ",cop_response)
            //request
            try{
                let response = await LoginRequest({phone:fixNumbers(mobile)})

                //post success request
                setLoginState(false);

                //set Mobile to Suggestion
                let suggestion_obj = [];
                let suggestion_storage = localStorage.getItem("mobileSuggestion");
                if(suggestion_storage){
                    suggestion_obj = JSON.parse(suggestion_storage);
                }

                //Check Suggestion Exist
                let exist = suggestion_obj.find(item=>item.mobile===fixNumbers(mobile))
                if(!exist){
                    suggestion_obj.push({mobile:fixNumbers(mobile)})
                }
                localStorage.setItem("mobileSuggestion",JSON.stringify(suggestion_obj))

                //clear


                history.push("/verify",{
                    token:response.data.token,
                    mobile:mobile,
                    mall:cop_response.data.merchant.mall,
                    coupon:cop_response.data.uid
                })
                MessageHandler({type:"LOGIN",status:"SUCCESS"})
            }catch (e) {
                console.log(e)
                //post failed request
                setLoginState(false);
                MessageHandler({type:"LOGIN",status:"ERROR"})
            }


        }catch (e) {
            console.log("e : ",e)
            toaster.notify(({ onClose }) => (<Error   message={"کد کوپن معتبر نمیباشد"}/>),{duration: 2000});
            setLoginState(false);
            return
        }

    }



    const Login_Request = async () => {
        if(loginState){return }
        // pre request
        setLoginState(true);

        if (!Validation({type:"MOBILE",val:fixNumbers(mobile)})){
            MessageHandler({type:"VALIDATION",status:"MOBILE"})
            setLoginState(false);
            return ;
        }



        //request
        try{
            let response = await LoginRequest({phone:fixNumbers(mobile)})

            //post success request
            setLoginState(false);

            //set Mobile to Suggestion
            let suggestion_obj = [];
            let suggestion_storage = localStorage.getItem("mobileSuggestion");
            if(suggestion_storage){
                suggestion_obj = JSON.parse(suggestion_storage);
            }

            //Check Suggestion Exist
            let exist = suggestion_obj.find(item=>item.mobile===fixNumbers(mobile))
            if(!exist){
                suggestion_obj.push({mobile:fixNumbers(mobile)})
            }
            localStorage.setItem("mobileSuggestion",JSON.stringify(suggestion_obj))

            //clear


            history.push("/verify",{
                token:response.data.token,mobile:mobile,
                mall:merchant.mall,
                coupon:coupon.uid
            })
            MessageHandler({type:"LOGIN",status:"SUCCESS"})
        }catch (e) {
            console.log(e)
            //post failed request
            setLoginState(false);
            MessageHandler({type:"LOGIN",status:"ERROR"})
        }
    }

    const [couponMessage,set_couponMessage] = useState("به منظور فعال کردن کوپن تخفیف , کد روی کارت را وارد نمایید ")

    const CouponComponent = ({item})=>{

        switch (item.coupon_type) {
            case 'discount_percent':
                return(
                    <div key={coupon.uid} className="slider-gift-section" style={{width:"100%"}}>
                        <div className="gift-section-ticket">

                            <div className="gift-section-ticket-off reward_level_2">
                                                <span className="gift-section-ticket-off-number"><span
                                                    className="off-number">{coupon.discount_value ? coupon.discount_value : " 0 "}</span>%</span>
                                <span className="gift-section-ticket-off-label"> تخفیف </span>
                            </div>

                            <div className="gift-section-ticket-info">
                                <div className="rotated-half-up-circle"></div>
                                <div className="rotated-half-down-circle"></div>
                                <span
                                    className="gift-section-ticket-info-title" style={{paddingRight: 11,fontSize:14}}>{coupon.campaign_title}</span>
                                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                                    <div style={{display:'flex',flexDirection:"column"}}>
                                        <span className="coupon_date"> از تاریخ  {ConvertToJalaliSplited(coupon.valid_from_date)} </span>
                                        <span className="coupon_date"> تا تاریخ {ConvertToJalaliSplited(coupon.valid_to_date)}</span>
                                    </div>
                                    {/*<span>{ConvertToJalaliSplited(coupon.valid_to_date)}</span>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                )

                break;
            case 'discount_amount':
                return(
                    <div key={coupon.uid} className="slider-gift-section" style={{width:"100%"}}>
                        <div className="gift-section-ticket">

                            <div className="gift-section-ticket-off reward_level_2">
                                                <span className="gift-section-ticket-off-number"><span
                                                    className="off-number">{coupon.discount_value ? coupon.discount_value/1000 : " 0 "}</span></span>
                                <span className="gift-section-ticket-off-label">  ریال </span>
                            </div>

                            <div className="gift-section-ticket-info">
                                <div className="rotated-half-up-circle"></div>
                                <div className="rotated-half-down-circle"></div>
                                <span
                                    className="gift-section-ticket-info-title" style={{paddingRight: 11,fontSize:14}}>{coupon.campaign_title}</span>
                                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                                    <div style={{display:'flex',flexDirection:"column"}}>
                                        <span className="coupon_date"> از تاریخ  {ConvertToJalaliSplited(coupon.valid_from_date)} </span>
                                        <span className="coupon_date"> تا تاریخ {ConvertToJalaliSplited(coupon.valid_to_date)}</span>
                                    </div>
                                    {/*<span>{ConvertToJalaliSplited(coupon.valid_to_date)}</span>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                )

                break;
            case 'reward_item':
                return(
                    <div key={coupon.uid} className="slider-gift-section" style={{width:"100%"}}>
                        <div className="gift-section-ticket">

                            <div className="gift-section-ticket-off reward_level_2">
                                                <span className="gift-section-ticket-off-number"><span
                                                    className="off-number">{coupon.discount_value ? coupon.discount_value : " 0 "}</span></span>
                                <span className="gift-section-ticket-off-label">  </span>
                            </div>

                            <div className="gift-section-ticket-info">
                                <div className="rotated-half-up-circle"></div>
                                <div className="rotated-half-down-circle"></div>
                                <span
                                    className="gift-section-ticket-info-title" style={{paddingRight: 11,fontSize:14}}>{coupon.campaign_title}</span>
                                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                                    <div style={{display:'flex',flexDirection:"column"}}>
                                        <span className="coupon_date"> از تاریخ  {ConvertToJalaliSplited(coupon.valid_from_date)} </span>
                                        <span className="coupon_date"> تا تاریخ {ConvertToJalaliSplited(coupon.valid_to_date)}</span>
                                    </div>
                                    {/*<span>{ConvertToJalaliSplited(coupon.valid_to_date)}</span>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                )
                break;
        }
    }



    return (
        <Spin spinning={couponLoading}>
            <div className="landing-container">
                <div className="a-pluse-subject">
                    {merchant?<img src={merchant.thumbnail} alt=""/>:null}
                    {merchant?<span> {merchant.name}</span>:null}
                </div>
                <div className="menu-container landing-back" style={{
                    backgroundImage: `url(${merchant?merchant.cover:"https://test-loyalty-minio.darkube.app/loyalty-media/merchant/merchant/images/cover_dwOPQ03-min.jpg"})`}}>

                    <Rodal  customStyles={{width:'90%', height: 'auto',
                        bottom: 'auto',
                        top: '20%'}} animation={"zoom"} visible={showModal} showCloseButton={false} onClose={() => setShowModal(false)}>
                        <div className="product-modal">
                            <img className="productItem-img" src={productItem.image} alt=""/>
                            <span className="productItem-name">{productItem.name}</span>
                            <span className="productItem-price">{productItem.price} ریال  </span>
                            <div className="productItem-desc">
                                <span>توضیحات</span>
                                {productItem && productItem.des?<p className={productItem.des.length>130?"product-item-scroll":""}>{productItem.des}</p>:null}
                            </div>
                        </div>
                    </Rodal>



                    {/* ------------- Chart Section ----------------- */}
                    <div className={!isLogin?"services-section":"services-section-login"} >
                        {/*<a href="tel:*556%23">Check balance</a>*/}
                        {!isLogin?<div className="get-mobile-section">
                            <p>برای بهره‌مندی از مزایای باشگاه مشتریان  شماره تلفن خود را وارد کنید.</p>
                            <div className="input-mobile">
                                <input
                                    value={mobile}
                                    onChange={(e)=>{
                                        setMobile(e.target.value)
                                    }}
                                    type="text" name="" id="" placeholder="شماره تلفن"/>
                                <i className="fa fa-mobile badg-icon"></i>
                            </div>
                            {!merchant?
                                <>
                                    <br/>

                                    <div className="input-mobile">
                                        <input
                                            value={couponCode}
                                            onChange={(e)=>{
                                                set_couponCode(e.target.value)
                                            }}
                                            type="text" name="" id="" placeholder="کد کوپن"/>
                                        <i className="fa fa-mobile badg-icon"></i>
                                    </div>
                                </>
                                :null}

                            <div className="input-login-btn-coupon" onClick={()=>{
                                if(merchant){
                                    Login_Request()
                                }else {
                                    Login_Request_Coupon()
                                }
                            }}>
                                {loginState?<i className="fa fa-spinner fa-spin"></i>: <i className="fa fa-angle-left"></i>}
                                <span>ورود</span>
                            </div>

                        </div>:null}

                    </div>
                    <div className="merchant-desc" style={isLogin && coupon?{paddingTop:10}:{paddingTop:100}}>
                        <p>{merchant && merchant.description}</p>
                        {!coupon && isLogin?<p className="coupon_message">{couponMessage}</p>:""}
                        {coupon.uid?
                            <CouponComponent item={coupon}/>
                            :null}
                    </div>

                       {isLogin && merchant ?
                           <div className="online-store-sec land-btn" onClick={async ()=>{
                               if(merchant){
                                   let malli = merchant.mall;
                                   await CheckinData("mc_"+malli.uid)
                                   localStorage.setItem('mallId',malli.uid);
                                   localStorage.setItem('mallLogo',malli.header_image);
                                   localStorage.setItem('mallWhite',malli.logo);
                                   localStorage.setItem('mallName',malli.name);
                                   localStorage.setItem('mall',JSON.stringify(malli));
                                   setMall(malli);
                                   history.push("/",{coupon:coupon.uid})
                               }else {
                                   toaster.notify(({ onClose }) => (<Error   message={"کد کوپن معتبر نمیباشد"}/>),{duration: 2000});
                               }
                           }}>
                               <div className="online-store-btn">
                                   {loginState?<i className="fa fa-spinner fa-spin"></i>: <i></i>}
                                   <span>فعال کردن  کوپن</span>
                               </div>
                           </div>:null}

                           <div className="coupon_p2_wr">

                              <div className="coupon_p2_sec">
                                  {isLogin && !merchant? <div className="online-store-sec land-btn coupon_p2_land"  >
                                      <div className="input-mobile">
                                          <input
                                              value={couponCode}
                                              onChange={(e)=>{
                                                  set_couponCode(e.target.value)
                                              }}
                                              type="text" name="" id="" placeholder="کد کوپن"/>
                                          <i className="fa fa-mobile badg-icon"></i>
                                      </div>
                                      <br/>
                                      <div className="online-store-btn" onClick={async ()=>{
                                          setLoginState(true)
                                          //check coupon
                                          if(couponCode===""){
                                              toaster.notify(({ onClose }) => (<Error   message={"کد کوپن را وارد نمایید"}/>),{duration: 2000});
                                              setLoginState(false)
                                              return ;
                                          }
                                          try {
                                              const cop_response = await CouponData(couponCode);
                                              console.log("Cop : ",cop_response)
                                              setLoginState(false)
                                              let malli = cop_response.data.merchant.mall;
                                              await CheckinData("mc_"+malli.uid)
                                              localStorage.setItem('mallId',malli.uid);
                                              localStorage.setItem('mallLogo',malli.header_image);
                                              localStorage.setItem('mallWhite',malli.logo);
                                              localStorage.setItem('mallName',malli.name);
                                              localStorage.setItem('mall',JSON.stringify(malli));
                                              setMall(malli);
                                              history.push("/",{coupon:cop_response.data.uid})
                                          }catch (e) {
                                              console.log("e : ",e)
                                              setLoginState(false)
                                              toaster.notify(({ onClose }) => (<Error   message={"کد کوپن معتبر نمی باشد"}/>),{duration: 2000});
                                              return
                                          }

                                      }}>
                                          {loginState?<i className="fa fa-spinner fa-spin"></i>: <i></i>}
                                          <span>فعال کردن کوپن </span>
                                      </div>
                                  </div>:null}
                              </div>


                           </div>

                </div>
            </div>
            </Spin>
    )
}

export {Coupon};
